import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { VpConditionalWrapper, VpHoverInfo } from '../';
import { getPlanUpgrade } from '../../../utils';
import { getIsOrganizationViewer } from '../../../redux/modules/organization';
import { getFeaturePermissions } from '../../../redux/modules/auth';

const isChildFunc = (children) => typeof children === 'function';

export const ConditionalUpgradeWrapper = ({
  condition = undefined,
  featureKey,
  label,
  tooltipProps,
  children,
  isOrgViewer,
  viewerRestricted = true,
  featurePermissions,
  fullWidth = false,
  disableFlex = false,
  multiUserCheck = false
}) => {
  const hoverProps = {
    disablePointer: true,
    ...tooltipProps
  };

  const plan = getPlanUpgrade(featureKey);
  const hoverLabel = useMemo(() => {
    if (label) {
      return label;
    }

    if (isOrgViewer && viewerRestricted) {
      return 'You do not have permissions to perform this action for this organization.';
    }

    return (
      <span>
        Upgrade{plan ? ` to ${plan}` : ''} on the <Link to="/billing">billing page</Link> to access
        this feature.
      </span>
    );
  }, [label, isOrgViewer, viewerRestricted, plan]);

  const shouldUseCondition = condition !== undefined;
  const featureValue = featurePermissions?.[featureKey]?.value;
  const disabledCondition = shouldUseCondition ? condition : !featureValue;
  const isDisabled = (viewerRestricted && isOrgViewer) || (!multiUserCheck && disabledCondition);
  const childProps = {
    isDisabled
  };

  return (
    <VpConditionalWrapper
      condition={isDisabled}
      wrapper={(conditionalChildren) => {
        return (
          <VpHoverInfo
            fullWidth={fullWidth}
            disableFlex={disableFlex}
            disableInteractive={false}
            label={hoverLabel}
            {...hoverProps}
          >
            {isChildFunc(conditionalChildren)
              ? conditionalChildren(childProps)
              : conditionalChildren}
          </VpHoverInfo>
        );
      }}
    >
      {isChildFunc(children) ? children(childProps) : children}
    </VpConditionalWrapper>
  );
};

ConditionalUpgradeWrapper.propTypes = {
  condition: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  tooltipProps: PropTypes.object,
  featureKey: PropTypes.string,
  isOrgViewer: PropTypes.bool,
  viewerRestricted: PropTypes.bool,
  featurePermissions: PropTypes.object,
  fullWidth: PropTypes.bool,
  disableFlex: PropTypes.bool,
  multiUserCheck: PropTypes.bool
};

const mapStateToProps = (state) => ({
  isOrgViewer: getIsOrganizationViewer(state),
  featurePermissions: getFeaturePermissions(state)
});

export const VpConditionalUpgradeWrapper = connect(mapStateToProps)(ConditionalUpgradeWrapper);

export default connect(mapStateToProps)(ConditionalUpgradeWrapper);



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpConditionalUpgradeWrapper/VpConditionalUpgradeWrapper.jsx